import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {
        "search": "",
        "sort": {
            "attributes": ["created_date"],
            "sorts": ["desc"]
        },
        "filters": [
            // ["id","=",3]
        ],
        "pageNo":1,
        "itemsPerPage": 12
    },
    yearfilter: {
        "listType":"ebook_year",
        "replacements":["%%"]
    },
};

const eBookSlice = createSlice({
    name: 'eBook',
    initialState,
    reducers: {
        updateFilter: (state, action) => {
            state.filters = action.payload;
        },
        updateReducer: (state, action) => {
            state.filters = action.payload;
        },
    },
});

export const {
    updateFilter,
    updateReducer,
} = eBookSlice.actions;

export default eBookSlice.reducer;
